<template>
  <div class="edit-gift">
    <headerNotice routerName="编辑评论"></headerNotice>
    <div v-loading='loading' class="content">
      <el-form
        ref="form"
        style="margin-left: 28% ;"
        :rules="rules"
        :model="form"
        label-width="150px"
      >
        <el-form-item label="产品名称: " prop="productName">
          <el-input class="input-el" v-model="form.productName" placeholder="请输入礼品名称"></el-input>
        </el-form-item>
          <el-form-item label="排序: " prop="sort">
          <el-input class="input-el" v-model="form.sort" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="测评类型: " prop="type">
          <el-select v-loading='opLoading' v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评论图片: " prop="fileName" ref='fileName'>
          <el-upload
            :accept='accept'
            class="upload"
            :action="uploadAction"
            :headers="headers"
            :on-success="upImgsSuccess"
            :file-list="imagesList"
            list-type="picture-card"
            :before-upload="beforeUpload"
            :on-remove="imgsRemove"
            :limit="5"
            :on-exceed="handleExceed"
          >
          </el-upload>
        </el-form-item>
        <el-form-item label="测评内容: " prop="comment">
          <el-input
            :rows='4'
            resize="none"
            type="textarea"
            class="input-el"
            v-model="form.comment"
            placeholder=""
            maxlength='300'
            ></el-input>
        </el-form-item>
        <el-form-item label="审核: " prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item style="margin-left: 10%;">
          <el-button :loading="loading" @click="submit" type="primary">提交</el-button>
          <el-button @click="back">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import headerNotice from "../../components/common/headerNotice.vue";
export default {
  components: {
    headerNotice
  },
  data() {
    var hasImg = (rule, value, callback) => {
      if (!this.form.fileName.length) {
        callback(new Error("请上传图片"));
      } else {
        callback();
      }
    };
    var hasDescImg = (rule, value, callback) => {
      if (!this.form.descripImages.length) {
        callback(new Error("请上传图片"));
      } else {
        callback();
      }
    };
    var isInt = (rule, value, callback) => {
      if(/^(([0-9]*[1-9][0-9]*)|(0))$/.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的数量"));
      }
    };
    var isPricre = (rule, value, callback) => {
      if(this.isMoney(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的金额"));
      }
    }
    var maxExchange = (rule, value, callback) => {
      if(this.isMoney(value) || value === '') {
        callback();
      } else {
        callback(new Error("请输入正确的金额"));
      }
    }
    return {
      loading: false,
      opLoading: false,
      rules: {
        // title: { required: true, message: "请输入礼品名称", trigger: "change" },
     
      },
      form: {
        title: "",
        cateID: "",
        stock: "",
        fileName: [],
        disPoints: '',
        costPrice: '',
        integral: '',
        maxExchangeNum: '',
        explain: '',
        descripImages: [],
        status: ''
      },
      options: [
        {value:1,label:"优秀"},
         {value:2,label:"普通"}
      ],
      accept:".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
      headers: {
        Authorization: localStorage.getItem("accessToken")
      },
      // headers: {
      //   'Authorization': sessionStorage.getItem('accessToken'),
      // }, //正式头部
      uploadAction:
        this.$store.state.apiUrl + "/api/services/app/Image/UploadImage",
      imagesList: [],
      imagesDescList: [],
      baseUrl: this.$store.state.URL,
      itemID: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    submit(formName) {
      this.$refs.form.validate(valid => {
        if (valid) {
          console.log(this.form)
          // this.$emit("sendData", this.form, this.type);
          this.updateIntegralItem(this.form)
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    back() {
      this.$router.push({
        path: '/OnTrialCommentList'
      })
    },
    // 编辑商品
    updateIntegralItem(formData) {
      let data = Object.assign({}, formData)
      let self = this;
      // self.loading = true
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminOnTrialExchange/UpdateComment",
        data: data,
        success(res) {
          self.$message.success('操作成功！')
          self.$router.push({
            path: '/OnTrialCommentList'
          })
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    // 礼品图片
    upImgsSuccess(response, file, fileList) {
      this.form.fileName.push(response.result.fileName);
      this.imagesList.push({
        name: response.result.fileName,
        url: this.baseUrl + response.result.url
      });
      this.$refs.fileName.clearValidate()
    },
    imgsRemove(file, fileList) {
      this.imagesList = fileList;
      this.form.fileName = []
      this.imagesList.forEach((item) => {
        this.form.fileName.push(item.name)
      })
    },
    // 礼品描述
    upImgsDescSuccess(response, file, fileList) {
      this.form.descripImages.push(response.result.fileName);
      this.imagesDescList.push({
        name: response.result.fileName,
        url: this.baseUrl + response.result.url
      });
      this.$refs.descripImages.clearValidate()
    },
    imgsDescRemove(file, fileList) {
      this.imagesDescList = fileList;
      this.form.descripImages = []
      this.imagesDescList.forEach((item) => {
        this.form.descripImages.push(item.name)
      })
    },
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (file.type != "image/jpeg" && file.type != "image/png") {
        this.$message.error("上传的图片只支持JPG/PNG 的格式!");
        return false;
      }
      return true;
      if (!isLt10M) {
        this.$message.error("上传图片大小不能超过 10M!");
      }
      return isLt10M;
    },
    handleExceed() {
      this.$message.error("抱歉，最多上传五张图片！");
    },
    isMoney(money) {
      return /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(money);
    },
    // 获取详情
    getAdminUpdateIntegralItem(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminOnTrialExchange/GetCommentDetails",
        params: params,
        success(res) {

          self.form = res
           self.dealFileName(res.images)
          // self.dealDescripImages(res.descripImages)
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    dealFileName(data) {
      debugger
      let temp = []
      let temp2 = []
      data.forEach((item) => {
        let name = item.fileName
        temp.push(name)
        temp2.push({
          name: name,
          url: this.baseUrl + item.url
        })
      })
      this.form.fileName = temp
      this.imagesList = temp2
    },
    dealDescripImages(data) {
      let temp = []
      let temp2 = []
      data.forEach((item) => {
        let name = item.fileName
        temp.push(name)
        temp2.push({
          name: name,
          url: this.baseUrl + item.url
        })
      })
      this.form.descripImages = temp
      this.imagesDescList = temp2
    }
  },
  created() {
    this.getAdminUpdateIntegralItem({
      Id: this.$route.query.itemID
    })
    this.itemID = this.$route.query.itemID
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.edit-gift {
  .content {
    padding: 20px 50px 0;
  }
  .tips {
    margin: -10px 0 12px 13%;
    color: #999;
    font-size: 12px;
  }
  .upload {
    width: 500px;
    // border: 1px solid #e4e4e4;
    // border-radius: 4px;
  }
  .input-el {
    width: 460px;
  }
}
</style>